<template>
  <app-dropdown
    placeholder="Filter by Status"
    track-by="id"
    label="label"
    :options="statusSelection"
    :loading="loading"
    :disabled="dropdownDisabled"
    v-bind="attrs"
    @on-selected="onStatusSelected"
    @on-removed="onStatusRemoved"
  />
</template>

<script>
import AppDropdown from "../AppComponents/AppDropdown.vue";
import ApiMixin from "../../mixins/ApiMixin";
import CampaignServices from "../../services/campaigns";

/**
 * The value that indicates that selecting this from the
 * dropdown means the user is trying to select all
 * statuses.
 */
export const OrderStatusListAllOption = {
  id: 0,
  label: "All Status",
};

export default {
  mixins: [ApiMixin],
  components: {
    AppDropdown
  },
  computed: {
    attrs() {
      const { placeholder, options, ...rest } = this.$attrs;
      return rest;
    },
    // Function to determine if the dropdown should be disabled
    dropdownDisabled() {
      if (this.loading) return true;
      if (this.attrs.disabled) return this.attrs.disabled;

      return false;
    },
    // Holds the data for the status selection to be displayed
    statusSelection() {
      let baseSelection = [];

      if (!this.response) return baseSelection;

      baseSelection = this.response.data.map(response => ({
        id: response.mappedStatus.toLowerCase(),
        label: response.mappedStatus
      }))

      return [OrderStatusListAllOption, ...baseSelection];
    }
  },
  methods: {
    async fetchStatuses() {
      await this.request(CampaignServices.getStatuses);
    },
    onStatusSelected(props) {
      this.$emit("on-order-status-selected", props);
    },
    onStatusRemoved(props) {
      this.$emit("on-order-status-removed", props);
    }
  },
  mounted() {
    this.fetchStatuses();
  },
  inheritAttrs: false
};
</script>
